export default theme => ({
  root: {
    display: 'block',
    height: 0,
    borderTop: `1px solid ${theme.colors.grey[100]}`
  }
});